import { getMsgFromApiErr } from "@api/api";
import useRequestState from "@hooks/useRequestState";
import { useCallback, useEffect } from "react";
import getNotifications, { Notification } from "../getNotifications";

const useGetNotifications = (autoSend?: boolean) => {
  const { reqState, setLoading, setSuccess, setError } = useRequestState<Notification[]>([]);

  const send = useCallback(async () => {
    setLoading();
    try {
      const notifications = await getNotifications();
      return setSuccess(notifications);
    } catch (err: any) {
      return setError(getMsgFromApiErr(err));
    }
  }, [setError, setLoading, setSuccess]);

  useEffect(() => {
    if (autoSend) send();
    // prevents infinite loop
    // eslint-disable-next-line
  }, [autoSend]);

  return { ...reqState, data: reqState.data, send };
};

export default useGetNotifications;
